<template>
    <div class="d-inline-block">
        <template>
            <button class="btn btn-sm btn-outline-primary ml-1" type="button" :class="{ 'border-0': sem_bordas }"
                :disabled="disabled" @click="open_url_estudo()" data-toggle="tooltip" data-placement="top"
                title="Visualizar Imagens do PACS">
                <slot>
                    <i class="fas fa-x-ray"></i>
                </slot>
            </button>
        </template>
    </div>

</template>

<script>

export default {
    data() {
        return {
            response: null
        }
    },

    props: [
        "id_atendimento_procedimento",
        "id_paciente",
        "accession_number",
        "toast",
        "disabled",
        "sem_bordas"
    ],

    methods: {
        open_url_estudo() {
            this.$util.load(this, {
                service: 'pep',
                func: 'url_estudo_pacs',
                redir_api: true,
                parms: {
                    id_atendimento_procedimento: this.id_atendimento_procedimento,
                    id_paciente: this.id_paciente,
                    accession_number: this.accession_number,
                    toast: this.toast,
                    is_host_public: (this.$util.getCookie('cn-hpvip') == 'S'),
                },
                loadTo: (res) => {
                    if (res && res.url) {
                        this.$util.pacs_open_window(res.url);
                    } else {
                        if (res && res.msg) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 3000
                            });
                        } else {
                            let params = 'msg=Estudo não disponível no PACS: #' + this.id_atendimento_procedimento + ' / ' + this.id_paciente;
                            params = new URLSearchParams(params).toString();
                            this.$util.pacs_open_window_default(params);
                        }
                    }
                }
            });
        }
    }
};
</script>